export default __webpack_public_path__ + "static/media/phone_verif.d017e1ae.svg";